import { postJson } from "../methods";
function createUserCompanyPeers_default(peerCollection, headers = {}) {
  const config = {
    url: `backend/company-peers/user/peers`,
    headers,
    payload: peerCollection
  };
  return postJson(config);
}
export {
  createUserCompanyPeers_default as default
};
